import { cn } from "@/src/lib/utils";
import { ReactNode } from "react";

export function SettingsPage(props: {
  title: string;
  description: string;
  children: ReactNode;
  className?: string;
  action?: ReactNode;
}) {
  return (
    <div className={cn("w-full max-w-2xl space-y-6", props.className)}>
      <div className="flex items-start justify-between gap-4">
        <div className="space-y-1">
          <h1 className="text-xl font-semibold tracking-tight text-foreground">
            {props.title}
          </h1>
          <p className="text-sm text-muted-foreground">{props.description}</p>
        </div>
        {props.action}
      </div>
      <div className="h-px bg-border" />
      <div className="space-y-6">{props.children}</div>
    </div>
  );
}

export function SettingsCard(props: {
  title: string;
  description?: string;
  children: ReactNode;
  action?: ReactNode;
  className?: string;
  contentClassName?: string;
}) {
  return (
    <section
      className={cn(
        "rounded-lg border border-border bg-card text-card-foreground shadow-sm",
        props.className,
      )}
    >
      <div className="flex items-start justify-between gap-4 px-5 py-4">
        <div className="space-y-1 min-w-0">
          <h2 className="text-sm font-semibold leading-none text-foreground">
            {props.title}
          </h2>
          {props.description ? (
            <p className="text-sm text-muted-foreground">{props.description}</p>
          ) : null}
        </div>
        {props.action ? (
          <div className="shrink-0">{props.action}</div>
        ) : null}
      </div>
      <div className={cn("border-t border-border", props.contentClassName)}>
        {props.children}
      </div>
    </section>
  );
}

export function SettingsRow(props: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex items-start justify-between gap-4 px-5 py-4",
        props.className,
      )}
    >
      {props.children}
    </div>
  );
}

export function SettingsEmpty(props: { children: ReactNode }) {
  return (
    <p className="px-5 py-8 text-center text-sm text-muted-foreground">
      {props.children}
    </p>
  );
}
